import styled from 'styled-components';

const LoadingMLStyled = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  .backdrop {
    position: absolute;
    z-index: 11;
    visibility: ${(props) => (props.loading ? 'visible' : 'hidden')};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 12px;
    /* background-color: yellow; */
  }
`;

export { LoadingMLStyled };
